import { HeatMap } from '../models/map.heatMap';
import { MapLatLng } from '../models/map.latlng';
import { MapMarker } from '../models/map.marker';

declare var google: any;

export class GMapHeatMap extends HeatMap {
    constructor(id: number, map: any, points: MapLatLng[], markers: MapMarker[], radius: number,
        dissipating: boolean, maxIntensity: number, opacity: number, gradient: any[]) {
        super(id, map, points);
        // Creo el array con los puntos
        const data: any = [];
        if (points) {
            points.forEach(point => {
                if (point.weight === 1) {
                    data.push(new google.maps.LatLng(point.lat, point.lng));
                } else {
                    data.push({ location: new google.maps.LatLng(point.lat, point.lng), weight: point.weight });
                }
            });
        }
        if (markers) {
            markers.forEach(marker => {
                if (marker.position.weight === 1) {
                    data.push(new google.maps.LatLng(marker.position.lat, marker.position.lng));
                } else {
                    data.push({
                        location: new google.maps.LatLng(marker.position.lat, marker.position.lng),
                        weight: marker.position.weight
                    });
                }
            });
        }
        this.heatMap = new google.maps.visualization.HeatmapLayer({
            data: data,
            radius: radius > 0 ? radius : 20, // Radio de influencia de cada unidad en pixels
            dissipating: dissipating,         // true=Se ven los puntos sólo al máximo zoom, false=Se ven los puntos siempre
            maxIntensity: maxIntensity,       // 0=Máximo nivel en función de los pesos, Otro valor máximo nivel fijo
            opacity: opacity,                 // Por defecto 0.6
            gradient: gradient                // Gradiente CSS
        });
        this.heatMap.setMap(map);
    }

}
